/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type OrgRole = (typeof OrgRole)[keyof typeof OrgRole];

export const OrgRole = {
    Member: 1,
    Admin: 2,
    Owner: 3,
} as const;
